import { useState, forwardRef, useMemo, useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';
import { ShopbyFestivalComponents, ShopbyFestivalComponentGrid } from '../../@types/aboutfishing';
import FestivalGridItem from './FestivalGridItem';


interface FestivalGridProps {
  el: ShopbyFestivalComponents
  getScrollMarginTop: string
}

const FestivalGrid = ({ el, getScrollMarginTop }: FestivalGridProps, ref: React.ForwardedRef<HTMLDivElement>) => {
  const [gridSwiper, setGridSwiper] = useState<SwiperClass | null>(null);
  const itemSplitNum = useMemo(() => (isMobile ? 9 : 5), []);
  
  const handlePrev = useCallback(() => {
    gridSwiper?.slidePrev();
  }, [gridSwiper]);

  const handleNext = useCallback(() => {
    gridSwiper?.slideNext();
  }, [gridSwiper]);

  const gridStyle = useMemo(() => ({
    display: 'grid',
    gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(5, 1fr)',
    gap: isMobile ? '7px' : '16px',
  }), [isMobile]);

  const slideLength = useMemo(() => Math.ceil(el.shopbyFestivalComponentGrids.length / itemSplitNum), [el.shopbyFestivalComponentGrids.length, itemSplitNum]);

  const renderSwiperSlides = useCallback(() => {
    return Array.from({ length: slideLength }).map((_, slideIndex) => (
      <SwiperSlide key={slideIndex}>
        <div style={gridStyle}>
          {el.shopbyFestivalComponentGrids
            .slice(slideIndex * itemSplitNum, slideIndex * itemSplitNum + itemSplitNum)
            .map((item: ShopbyFestivalComponentGrid, idx: number) => (
              <FestivalGridItem key={`${item.no}-${idx}`} item={item} />
            ))}
        </div>
      </SwiperSlide>
    ));
  }, [el.shopbyFestivalComponentGrids, itemSplitNum]);

  return (
    <div
      className="grid_module section center"
      id={`section${el.id}`}
      ref={ref}
      style={{ scrollMarginTop: getScrollMarginTop }}
      key={el.id}
    >
      <div className="head_img">
        <img src={isMobile ? el.mobileImageUrl : el.pcImageUrl} alt="" />
      </div>
      <div className="swiper_wrap">
        <Swiper
          spaceBetween={isMobile ? 7 : 16}
          slidesPerView={1}
          onSwiper={useCallback((swiper: SwiperClass) => setGridSwiper(swiper), [])}
          style={{ padding: '0px' }}
        >
          {renderSwiperSlides()}
        </Swiper>
        <button onClick={handlePrev} className="btnPrev" />
        <button onClick={handleNext} className="btnNext" />
      </div>
    </div>
  );
}

export default forwardRef(FestivalGrid);